import type { PendingWorkOrderCandidate, PendingWorkOrderCheck } from "./pending-work-order-check.js";
import { normalizeProductionUnit } from "../production/quantity.js";

/** Commercial identity must come from an independently verified source, never inferred from a candidate. */
export type PendingOrderSourceIdentity = { customerCode: string | null; salesOrder: string | null; salesLine: number | null };
const normalized = (value: string | null) => value?.trim().toLocaleUpperCase("tr-TR") || null;
export function assessPendingWorkOrder(candidate: PendingWorkOrderCandidate, source: PendingOrderSourceIdentity | null = null) {
  const blockers: string[] = [];
  if (candidate.statusCode !== 0 && candidate.statusCode !== 1) blockers.push("İş emri açık olarak doğrulanamadı.");
  if (normalizeProductionUnit(candidate.unit ?? "") !== "KOLİ") blockers.push("İş emrinin birimi KOLİ olarak doğrulanamadı.");
  if (candidate.countryMatch === "MISMATCH") blockers.push("Teslim ülkesi farklı.");
  const fields = [
    { label: "Müşteri", planned: source?.customerCode ?? null, actual: candidate.customerCode },
    { label: "Satış siparişi", planned: source?.salesOrder ?? null, actual: candidate.salesOrder },
    { label: "Sipariş satırı", planned: source?.salesLine == null ? null : String(source.salesLine), actual: candidate.salesLine == null ? null : String(candidate.salesLine) },
  ].map(field => ({ ...field, status: !normalized(field.planned) || !normalized(field.actual) ? "UNKNOWN" as const
    : normalized(field.planned) === normalized(field.actual) ? "MATCH" as const : "MISMATCH" as const }));
  for (const field of fields) if (field.status === "MISMATCH") blockers.push(`${field.label} kaynak kayıtla farklı.`);
  const unknown = fields.filter(field => field.status === "UNKNOWN").map(field => field.label);
  if (candidate.countryMatch === "UNKNOWN") unknown.push("Teslim ülkesi");
  return { fields, blockers, unknown, strong: blockers.length === 0 && unknown.length === 0,
    reason: blockers.length ? blockers.join(" ") : unknown.length ? `${unknown.join(", ")} kaynak bilgisi doğrulanamadı.` : "Ürün sorgu kapsamı, müşteri, satış siparişi/satırı, ülke ve birim doğrulandı." };
}
export function strongPendingWorkOrders(check: PendingWorkOrderCheck, source: PendingOrderSourceIdentity | null = null) {
  if (check.truncated || check.searchedWorkOrderNo) return [];
  const seen = new Set<string>();
  return check.candidates.filter(candidate => {
    if (seen.has(candidate.workOrderNo)) return false;
    seen.add(candidate.workOrderNo);
    return assessPendingWorkOrder(candidate, source).strong;
  }).slice(0, 2);
}
